/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_After_Stat_SetsInputs */

const en_us2_workout_after_stat_sets = /** @type {(inputs: Workout_After_Stat_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sets`)
};

const pt_br2_workout_after_stat_sets = /** @type {(inputs: Workout_After_Stat_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Séries`)
};

const es_419_workout_after_stat_sets = /** @type {(inputs: Workout_After_Stat_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Series`)
};

const pt_pt2_workout_after_stat_sets = /** @type {(inputs: Workout_After_Stat_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Séries`)
};

const fr_fr2_workout_after_stat_sets = /** @type {(inputs: Workout_After_Stat_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Séries`)
};

const de_de2_workout_after_stat_sets = /** @type {(inputs: Workout_After_Stat_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sätze`)
};

const it_it2_workout_after_stat_sets = /** @type {(inputs: Workout_After_Stat_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Serie`)
};

/**
* | output |
* | --- |
* | "Sets" |
*
* @param {Workout_After_Stat_SetsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_stat_sets = /** @type {((inputs?: Workout_After_Stat_SetsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_Stat_SetsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_stat_sets(inputs)
	if (locale === "es-419") return es_419_workout_after_stat_sets(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_stat_sets(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_stat_sets(inputs)
	if (locale === "de-DE") return de_de2_workout_after_stat_sets(inputs)
	if (locale === "it-IT") return it_it2_workout_after_stat_sets(inputs)
	return en_us2_workout_after_stat_sets(inputs)
});
export { workout_after_stat_sets as "workout-after.stat_sets" }